import React from "react";
import outline from "../../assets/icons/home_choose.svg";
import icon_4 from "../../assets/icons/home_choose_4.svg";
import banner from "../../assets/images/home_choose.jpg";
import Lottie from "lottie-react";
import mri_icon from "../../assets/animations/ct-scan (1).json"
import wallet from "../../assets/animations/wallet (1).json";
import nurse from "../../assets/animations/nurse (1).json";
const HomeChoose = () => {
  return (
    <div className=" xl:py-28 lg:py-20 md:py-14 py-10 relative bg-almond overflow-hidden">
      <div className="xl:top-0 top-40  md:left-0 right-0 absolute">
        <img src={outline} alt="outline" />
      </div>
      <div
        data-aos="fade-up"
        className="xl:w-[1280px] w-11/12 mx-auto xl:px-10 px-0 2xl:px-0 flex justify-center items-center flex-col z-10"
      >
        <span className="text-xl font-medium text-[#1d9e75] uppercase border-b border-[#B87333] px-2 py-1.5 ">
          Why Choose Me
        </span>
        <h2 className="lg:text-4xl md:text-3xl text-xl text-center font-bold mt-2 text-matcha leading-tight">
          Complete Healthcare Solution <br /> for our valuable Patients
        </h2>
        <div className="grid lg:grid-cols-2 grid-cols-1 w-full xl:gap-20 gap-10 mt-16">
          <div className="flex flex-col xl:gap-14 gap-7">
            <div className="flex sm:flex-row flex-col sm:gap-6 gap-3">
              <div className="flex flex-shrink-0 justify-center w-[90px] h-[90px] bg-matcha rounded-xl items-center">
                <div className="w-16 h-16">
                  <Lottie animationData={mri_icon} loop={true} />
                </div>
              </div>
              <div>
                <h4 className="text-xl font-bold text-matcha">
                  Modern Instrument
                </h4>
                <p className="text-base xl:leading-[26px] leading-tight text-matcha">
                  Diagnosy always try to provide the most common of get the
                  proper issuer for cure Healthcare
                </p>
              </div>
            </div>
            <div className="flex sm:flex-row flex-col sm:gap-6 gap-3">
              <div className="flex flex-shrink-0 justify-center w-[90px] h-[90px] bg-matcha rounded-xl items-center">
                <div className="w-16 h-16">
                  <Lottie animationData={wallet} loop={true} />
                </div>
              </div>
              <div>
                <h4 className="text-xl font-bold text-matcha">
                  Easy Billing System
                </h4>
                <p className="text-base xl:leading-[26px] leading-tight text-matcha">
                  Diagnosy always try to provide the Billing system of get the
                  proper very simple and easy
                </p>
              </div>
            </div>
            <div className="flex sm:flex-row flex-col sm:gap-6 gap-3">
              <div className="flex flex-shrink-0 justify-center w-[90px] h-[90px] bg-matcha rounded-xl items-center">
                <div className="w-16 h-16">
                  <Lottie animationData={nurse} loop={true} />
                </div>
              </div>
              <div>
                <h4 className="text-xl font-bold text-matcha">
                  Qualified Nurses & Staff
                </h4>
                <p className="text-base xl:leading-[26px] leading-tight text-matcha">
                  Diagnosy always try to provide qualified Nurses & Stuff are
                  get the proper cure Healthcare
                </p>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="absolute  -top-14 xl:-right-10 md:-right-5 md:visible invisible z-0">
              <img src={icon_4} alt="why choose icon" />
            </div>
            {/* Add "relative" here so z-10 actually takes effect */}
            <img
              src={banner}
              alt="why choose banner"
              className="relative h-full rounded-xl z-0"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeChoose;
